import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAppDispatch } from '../store';
import { clearTokens } from '../store/slices/authSlice';
import { persistor } from '../store';

export const useLogout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const logout = useCallback(async () => {
    dispatch(clearTokens());

    queryClient.clear();

    try {
      await persistor.purge();
      console.log('Persistor purged successfully');
    } catch (error) {
      console.error('Error purging persistor:', error);
    }

    try {
      localStorage.removeItem('report_auth_token');
      localStorage.removeItem('report_auth_cache');
    } catch (e) {
      console.error('Error clearing localStorage auth keys:', e);
    }

    navigate('/login', { replace: true });
  }, [dispatch, navigate, queryClient]);

  return { logout };
};
